import {bindMenu, bindTrigger, usePopupState} from "material-ui-popup-state/hooks"
import IconButton from "@material-ui/core/IconButton"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import {Link} from "react-router-dom"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import VisibilityIcon from "@material-ui/icons/Visibility"
import Typography from "@material-ui/core/Typography"
import {FormattedMessage} from "react-intl"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import React, {useState} from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Button from "@material-ui/core/Button"
import LoadingOverlay from "react-loading-overlay"
import {remove_record} from "../../../API"
import {useSelector} from "react-redux"
import AccessGuard from "../../AccessGuard"
import {Grid, Hidden, Slide} from "@material-ui/core"
import __ from "../../../LanguageHelper"
import Snackbar from "@material-ui/core/Snackbar"

export const DeleteConfirm = ({open, handleClose, tableRef, endpoint, id, onDelete}) => {
  const {token} = useSelector((state) => state.session)
  const [loading, setLoading] = useState(false)

  const deleteRecord = async () => {
    setLoading(true)

    await remove_record(endpoint, id, token)

    let modifiedData = tableRef.current.dataManager.data
    modifiedData = modifiedData.filter(x => x.id !== id)

    tableRef.current.dataManager.setData(modifiedData)

    onDelete && onDelete()

    setLoading(false)
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <LoadingOverlay
          active={loading}
        >
          <DialogTitle id="alert-dialog-title">{__('تأكيد الحذف', 'Confirm delete')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {__('هل أنت متأكد من حذف البيان؟', 'Are you sure you want to delete this record?')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="default">
              {__('إلغاء', 'Cancel')}
            </Button>
            <Button onClick={() => {
              deleteRecord().finally()
            }} color="primary" autoFocus>
              {__('تأكيد الحذف', 'Confirm Delete')}
            </Button>
          </DialogActions>
        </LoadingOverlay>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        key={`loader`}
        open={loading}
        TransitionComponent={Slide}
        message={__('جاري حذف البيانات...', 'Deleting record...')}
      />
    </>
  )
}


const ActionMenu = ({id, buttons = [], editAction, viewAction, normalView, rowData, protect = [], deleteRecord, endpoint}) => {
  const popupState = usePopupState({variant: 'popover', popupId: 'actionMenu'})

  if (protect.includes(rowData.id)) return null

  return (
    <div>
      <Hidden mdDown>
        <div style={{whiteSpace: 'nowrap', textAlign: 'center'}}>
          <AccessGuard permission={'read'} endpoint={endpoint}>
            {buttons.includes('show') && (
              <>
                {normalView ? <IconButton component={Link} to={`${window.location.pathname}/${id}`}>
                  <VisibilityIcon/>
                </IconButton> : <IconButton onClick={() => {
                  popupState.close()
                  viewAction && viewAction(rowData)
                }}>
                  <VisibilityIcon/>
                </IconButton>}
              </>
            )}
          </AccessGuard>

          <AccessGuard permission={'edit'} endpoint={endpoint}>
            {(buttons.includes('edit')) && <IconButton onClick={() => {
              editAction && editAction(rowData)
              popupState.close()
            }}>
              <EditIcon/>
            </IconButton>}
          </AccessGuard>

          <AccessGuard permission={'delete'} endpoint={endpoint}>
            {(buttons.includes('delete')) && <IconButton onClick={() => {
              deleteRecord()
              popupState.close()
            }}>
              <DeleteIcon style={{color: '#bf1111'}}/>
            </IconButton>}
          </AccessGuard>
        </div>
      </Hidden>

      <Hidden lgUp>
        <IconButton {...bindTrigger(popupState)}>
          <MoreVertIcon/>
        </IconButton>
        <Menu
          {...bindMenu(popupState)}
          getContentAnchorEl={null}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          transformOrigin={{vertical: 'top', horizontal: 'left'}}
        >

          <AccessGuard permission={'read'} endpoint={endpoint}>
            {buttons.includes('show') && (
              <>
                {normalView ? <MenuItem component={Link} to={`${window.location.pathname}/${id}`}>
                  <ListItemIcon>
                    <VisibilityIcon fontSize="small"/>
                  </ListItemIcon>
                  <Typography variant="inherit"><FormattedMessage id="datatable.show" defaultMessage="Show"/></Typography>
                </MenuItem> : <MenuItem onClick={() => {
                  popupState.close()
                  viewAction && viewAction(rowData)
                }}>
                  <ListItemIcon>
                    <VisibilityIcon fontSize="small"/>
                  </ListItemIcon>
                  <Typography variant="inherit"><FormattedMessage id="datatable.show" defaultMessage="Show"/></Typography>
                </MenuItem>}
              </>
            )}
          </AccessGuard>

          <AccessGuard permission={'edit'} endpoint={endpoint}>
            {(buttons.includes('edit')) && <MenuItem onClick={() => {
              popupState.close()
              editAction && editAction(rowData)
            }}>
              <ListItemIcon>
                <EditIcon fontSize="small"/>
              </ListItemIcon>
              <Typography variant="inherit"><FormattedMessage id="datatable.edit" defaultMessage="Edit"/></Typography>
            </MenuItem>}
          </AccessGuard>

          <AccessGuard permission={'delete'} endpoint={endpoint}>
            {(buttons.includes('delete')) && <MenuItem onClick={() => {
              deleteRecord()
              popupState.close()
            }}>
              <ListItemIcon>
                <DeleteIcon fontSize="small"/>
              </ListItemIcon>
              <Typography variant="inherit"><FormattedMessage id="datatable.delete" defaultMessage="Delete"/></Typography>
            </MenuItem>}
          </AccessGuard>
        </Menu>
      </Hidden>
    </div>
  )
}

export default ActionMenu
